import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductTransactionHistory, setFilters, resetFilters } from '../../features/product/productTransactionHistorySlice';
import Styles from '../../assets/css/components/pastTransaction/pastTransaction.module.scss';
import ItemImage from '../../assets/images/itemImage.png';
import { RiFilter2Line } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import Pagination from "../common/Pagination";
import Loader from "../../utils/Loader";

const PastTransaction = ({ showHeading = true }) => {
  const dispatch = useDispatch();
  const { transactions, loading, error, pagination, filters } = useSelector(state => state.productTransactionHistory);
  const [isOpen, setIsOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const [filterDate, setFilterDate] = useState({
    from: '',
    to: ''
  });
  const [dateError, setDateError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    dispatch(fetchProductTransactionHistory());
  }, [dispatch]);

  const handleSearch = (value) => {
    setSearchTerm(value);

    if (window.searchTimeout) {
      clearTimeout(window.searchTimeout);
    }

    window.searchTimeout = setTimeout(() => {
      dispatch(setFilters({
        ...filters,
        search: value,
        page: "1"
      }));
      dispatch(fetchProductTransactionHistory());
    }, 500);
  };

  const handleDateChange = (type, value) => {
    setFilterDate(prev => ({
      ...prev,
      [type]: value
    }));
    setDateError('');
  };

  const dateStatusApply = () => {
    // Validate that both dates are provided if any is provided
    if ((filterDate.from && !filterDate.to) || (!filterDate.from && filterDate.to)) {
      setDateError('Both From and To dates are required');
      return;
    }

    dispatch(setFilters({
      ...filters,
      from: filterDate.from,
      to: filterDate.to,
      transaction_status: statusFilter ? parseInt(statusFilter) : undefined,
      page: "1",
      sort: 'id',
      sort_order: 'desc'
    }));
    dispatch(fetchProductTransactionHistory());
    setIsOpen(false);
  };

  const getNoDataMessage = () => {
    if (statusFilter === "Outbound") {
      return "No Outbound Transactions Found";
    } else if (statusFilter === "Inbound") {
      return "No Inbound Transactions Found";
    }
    return "No Transactions Found";
  };

  const handleReset = () => {
    setFilterDate({ from: '', to: '' });
    setStatusFilter('');
    setSearchTerm('');
    setDateError('');
    dispatch(resetFilters());
    dispatch(fetchProductTransactionHistory());
    setIsOpen(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '/');
  };

  const changePage = (count, type) => {
    if (type === "page") {
      dispatch(setFilters({ ...filters, page: count.toString() }));
      dispatch(fetchProductTransactionHistory());
    }
    if (type === "show") {
      dispatch(setFilters({ ...filters, page: "1", paginate_per_page: count.toString() }));
      dispatch(fetchProductTransactionHistory());
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }

      if (isOpen && !event.target.closest(`.${Styles.filter_dropdown}`)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={`${Styles.transaction}`}>
      {showHeading && (
        <div className={`${Styles.transaction_heading}`}>
          <h2>Past Transaction</h2>
        </div>
      )}

      <div className={`${Styles.transactions_table}`}>

        {/* Filter And Search Data */}
        <div className={`${Styles.filter_search_btn}`}>
          <div className={`${Styles.filter}`}>
            <div className={`${Styles.sub_filter}`}>
              <button onClick={() => { setIsOpen(!isOpen); }}><RiFilter2Line /> Filter</button>
              {isOpen && (
                <div className={`${Styles.filter_dropdown}`}>
                  <div className={`${Styles.heading}`}>
                    <p>Filter</p>
                    <IoMdClose onClick={() => setIsOpen(!isOpen)} />
                  </div>

                  <div className={`${Styles.selectDate}`}>
                    <div className={`${Styles.heading_clear}`}>
                      <p>Select Date Range</p>
                      <p onClick={() => { setFilterDate({ from: '', to: '' }); setDateError(''); }}>Clear</p>
                    </div>
                    <div className={`${Styles.filter_date}`}>
                      <div className={`${Styles.from}`}>
                        <label htmlFor="from">From:</label>
                        <input
                          type="date"
                          id='from'
                          placeholder='00-00-0000'
                          value={filterDate.from}
                          max={filterDate.to || undefined}
                          onChange={(e) => handleDateChange('from', e.target.value)}
                        />
                      </div>
                      <div className={`${Styles.to}`}>
                        <label htmlFor="to">To:</label>
                        <input
                          type="date"
                          id='to'
                          placeholder='00-00-0000'
                          value={filterDate.to}
                          min={filterDate.from || undefined}
                          onChange={(e) => handleDateChange('to', e.target.value)}
                        />
                      </div>
                    </div>
                    {dateError && <div className={`${Styles.date_error}`} style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{dateError}</div>}
                  </div>

                  <div className={`${Styles.selectStatus}`}>
                    <div className={`${Styles.heading_clear}`}>
                      <p>Select Status</p>
                      <p onClick={() => setStatusFilter('')}>Clear</p>
                    </div>
                    <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                      <option value="" hidden>**** Select Status ****</option>
                      <option value="1">Inbound</option>
                      <option value="2">Outbound</option>
                    </select>

                  </div>

                  <div className={`${Styles.buttons}`}>
                    <button onClick={handleReset}>Reset</button>
                    <button onClick={dateStatusApply}>Apply Now</button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={`${Styles.search}`}>
            <div className={`${Styles.inputContainer}`}>
              <AiOutlineSearch className={`${Styles.searchIcon}`} />
              <input type="text" placeholder="Search by Product Name" value={searchTerm} onChange={(e) => handleSearch(e.target.value)} />
            </div>
          </div>
        </div>

        <div className={`${Styles.transactions_history}`}>
          <div className={`${Styles.item_table}`}>
            {loading ? (
              <div className={Styles.loader_container}>
                <Loader size="large" color="primary" />
              </div>
            ) : error ? (
              <div className={Styles.error_message}>
                {error}
              </div>
            ) : transactions.length === 0 ? (
              <div className={Styles.no_data}>
                {getNoDataMessage()}
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th className={`${Styles.first_row}`}>ID</th>
                    <th>Product name</th>
                    <th>Barcode number</th>
                    <th>Quantity</th>
                    <th>Status</th>
                    <th>Order date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((item) => (
                    <tr key={item.id}>
                      <td className={`${Styles.first_row}`}>{item.id}</td>
                      <td>
                        <div className={`${Styles.item_name}`}>
                          <img
                            src={item.product?.product_image?.[0]?.image_url || ItemImage}
                            alt="product"
                            className={`${Styles.item_icon}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = ItemImage;
                            }}
                          />
                          <span className={`${Styles.product_name_text}`}>
                            {item.product?.product_name || 'N/A'}
                          </span>
                        </div>
                      </td>
                      <td>{item.product?.barcode_number || 'N/A'}</td>
                      <td>{item.quantity || 'N/A'}</td>
                      <td>
                        <span className={`${Styles.status} ${item.transaction_status === "Inbound" ? Styles.inbound : Styles.outbound}`}>
                          {item.transaction_status}
                        </span>
                      </td>
                      <td>{formatDate(item.created_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Pagination */}
        {transactions && transactions.length > 0 && (
          <Pagination data={pagination} pageClick={changePage} />
        )}
      </div>
    </div>
  )
}

export default PastTransaction